module.exports = __webpack_public_path__ + "img/DSC_2811-xl.a98d1f04.png";